import { useTranslation } from '@mint-lib/i18n';
import { WarningAlt } from '@mint-lib/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type Props = {
  title?: string;
  text: string;
  open: boolean;
  onClose: () => void;
  onActionClick: () => void;
  actionButtonText?: string;
  cancelButtonText?: string;
};

const WarningConfirmModal = ({
  title,
  text,
  open,
  onClose,
  onActionClick,
  actionButtonText,
  cancelButtonText,
}: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="xs">
          <DialogHeader>
            <DialogTitle>
              <div className="flex items-center gap-2">
                <WarningAlt className="fill-warning-main" />
                <h5 className={typographyVariants({ variant: 'h5' })}>
                  {title}
                </h5>
              </div>
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <p className={typographyVariants({ variant: 'bodyLong01' })}>
              {text}
            </p>
          </DialogContent>
          <DialogFooter>
            <div className="flex w-full items-center justify-end gap-2">
              <Button
                variant="text"
                onClick={onClose}
                data-dd-action-name="cancel confirmation"
              >
                {cancelButtonText ?? t('Cancel')}
              </Button>
              <Button
                color="warning"
                onClick={onActionClick}
                data-dd-action-name="confirm destructive action"
              >
                {actionButtonText ?? t('Delete')}
              </Button>
            </div>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};

export default WarningConfirmModal;
